import axios from 'axios'
// Define base url
const BASE_URL = '/api/v1/employees'

// Define employees module
const employees = {
  state: {
    data: {},
    errors: {}
  },
  getters: {
    employees: state => {
      return state.data
    }
  },
  mutations: {
    setEmployeesData (state, payload) {
      state.data = payload
    }
  },
  actions: {
    async employeesGetData ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 200) {
          commit('setEmployeesData', response.data.data)
          return response.data.data
        }
      } catch (error) {
        Promise.reject(error)
      }
    }
  }
}

// Export the employees module
export default employees
